import { type CatalogPermissionUserConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import { useAssignSecondaryCategoriesToUserPresenter } from './useAssignSecondaryCategoriesToUserPresenter'
import { SecondaryCategoryAccessGrid } from '../../views/SecondaryCategoryAccessGrid'

export interface IAssignSecondaryCategoriesToUserPresenterProps {
  user: CatalogPermissionUserConfig
  onSuccess?: () => void
  onCancel?: () => void
}

export const AssignSecondaryCategoriesToUserPresenter = ({
  user,
  onSuccess,
  onCancel,
}: IAssignSecondaryCategoriesToUserPresenterProps) => {
  const { secondaryCategoryOptions, isSaving, isLoading, handleSave } =
    useAssignSecondaryCategoriesToUserPresenter({ user, onSuccess })

  return (
    <SecondaryCategoryAccessGrid
      user={user}
      secondaryCategoryOptions={secondaryCategoryOptions}
      isLoading={isLoading}
      isSaving={isSaving}
      onSave={handleSave}
      onCancel={onCancel}
    />
  )
}
